import React from "react";
import { useState, useMemo, useEffect } from "react";
import ListTable from "../utils/Table";
import Export from "../utils/Export";

import { all_product_sale_detail } from "../../actions/sales";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import notification_icon from "../../images/notification_icon.png";

export default function AllSaleList() {
  const dispatch = useDispatch();
  const rights = useSelector((state) => state.layout.rights);
  console.log(rights);
  const [tableData, setTableData] = useState({
    tableTitle: "Bill List",
    // deleteRecord: customer_delete,
    // updateRecord: customer_update,
    // onDeleteText: "Are you sure want to delete this customer?",
    // customisedStatusUpdateMessage: true,
    // onActiveText: "Are you sure you want to activate this customer?",
    // onInactiveText: [
    //   "Are you sure you want to inactivate this customer? ",
    //   "The customer will no longer be logged into the system once you inactivate it.",
    // ],
    disableDelete: true,
    // column_sum: {
    //   name: "invoice_amount",
    //   title: "Total Sales",
    // },
    tableHead: [
      {
        id: "date",
        label: "Sale On",

        link: "/Customer/CustomerDetail/CustomerDetail",
        color: "var(--gradientColor2)",
      },
      {
        id: "invoice",
        label: "Invoice No",
      },
      { id: "name", label: "Customer Name" },
      {
        id: "data",
        label: "No of Items",
      },
      // {
      //   id: "product",
      //   label: "Product",
      //   subText: "HSN",
      {
        id: "invoice_amount",
        label: "Bill Amount",
      },
      // },
      // {
      //   id: "quantity",
      //   label: "Quantity",
      // },
      // {
      //   id: "selling_price",
      //   label: "Selling Price",
      // },
      // {
      //   id: "final_price",
      //   label: "Final Price",
      // },

      // {
      //   id: "status",
      //   label: "Status",
      // },
    ],
    tableBody: [{}],
    filterColumn: [
      //   {
      //     id: "1",
      //     title: "Plan Type",
      //     name: "subscription",
      //     options: ["FREE", "TVOD", "SVOD"],
      //   },
      //   {
      //     id: "1",
      //     title: "Login By",
      //     name: "socialType1",
      //     options: ["Gmail", "AppleID", "Mobile", "WhatsApp"],
      //   },
      //   {
      //     id: "1",
      //     title: "Device Type",
      //     name: "deviceType",
      //     options: ["IOS", "Android"],
      //   },
    ],
    isDateRangeFilter: "created_at",
  });
  const [form, setForm] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  const Sale = useSelector((state) => state?.sales?.all_sale_list);

  useEffect(() => {
    dispatch(all_product_sale_detail());
  }, []);
  useMemo(() => {
    if (Sale?.statuscode == 200) {
      const temp = tableData;
      temp.tableBody = Sale?.data.map((ele) => ({
        ...ele,
        name: ele?.customer?.name,
        product: ele?.product?.product_name,
        HSN: ele?.product?.HSN,
        quantity:
          ele?.quantity + " " + ele?.product?.unit_of_measure?.unit_name,
        final_price: parseFloat(ele?.final_price).toFixed(2),
        selling_price: parseFloat(ele?.selling_price).toFixed(2),
        id: ele?.customer?.id,
      }));
      setTableData({ ...temp });
    }
  }, [Sale]);
  console.log(Sale, "8585");

  return (
    <>
      <Export
        fileName={"Sale"}
        access={rights?.["Sale"]?.["export_excel"] == "true"}
        exportData={tableData?.exportData || tableData?.tableBody}
        headings={tableData.tableHead.map((value) => value.label)}
      />

      <ListTable
        tableData={tableData}
        key={"ListTable"}
        setForm={setForm}
        setTableData={setTableData}
        setIsEdit={setIsEdit}
      />
    </>
  );
}
